import { Close, Payment as PaymentIcon } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import PaystackPayment from "../../hooks/PaystackPayment";
import { getAmount } from "../../utils/helper";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PaymentConfirmationModal({
  open,
  loading,
  handleSuccess,
  handleClose,
  paymentData,
  paystackConfig,
  isBulk = false,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const totalAmount = isBulk
    ? paymentData?.plans?.reduce(
        (sum, plan) => sum + parseFloat(plan.Plan?.amount || 0),
        0
      ) || 0
    : parseFloat(paymentData?.amount || 0);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="payment-dialog-title"
      className="p-10"
      sx={{ zIndex: 5000 }}
      TransitionComponent={Transition}
      maxWidth="sm"
      fullWidth
    >
      <DialogActions style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button color="error" onClick={handleClose} autoFocus>
          <Close />
        </Button>
      </DialogActions>
      <DialogTitle
        id="payment-dialog-title"
        display="flex"
        justifyContent="center"
        mt="0em"
      >
        <Avatar
          sx={{
            bgcolor: "var(--c-primary-1)",
            width: 56,
            height: 56,
          }}
        >
          <PaymentIcon fontSize="large" />
        </Avatar>
      </DialogTitle>
      <DialogContent>
        <Typography textAlign="center" fontSize="24px" fontWeight={600} mb={2}>
          {isBulk ? "Confirm Bulk Payment" : "Confirm Payment"}
        </Typography>

        <Box sx={{ bgcolor: "#f5f5f5", p: 2, borderRadius: 2, mb: 2 }}>
          {isBulk ? (
            <>
              <Typography variant="body2" color="text.secondary" mb={1}>
                Selected Plans ({paymentData?.plans?.length || 0})
              </Typography>
              <List dense sx={{ maxHeight: 200, overflow: "auto" }}>
                {paymentData?.plans?.map((plan, index) => (
                  <ListItem key={index} sx={{ px: 0 }}>
                    <ListItemText
                      primary={plan?.Plan?.name}
                      secondary={`${plan?.Plan?.Hmo?.name} - ₦${getAmount(
                        plan?.Plan?.amount
                      )}`}
                      primaryTypographyProps={{ fontSize: "14px" }}
                      secondaryTypographyProps={{ fontSize: "12px" }}
                    />
                  </ListItem>
                ))}
              </List>
              <Divider sx={{ my: 1 }} />
            </>
          ) : (
            <>
              <Stack spacing={1}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    Plan Name:
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {paymentData?.planName}
                  </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    HMO:
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {paymentData?.hmoName}
                  </Typography>
                </Box>
                <Divider sx={{ my: 1 }} />
              </Stack>
            </>
          )}

          <Box display="flex" justifyContent="space-between" mt={1}>
            <Typography variant="body1" fontWeight={600}>
              Total Amount:
            </Typography>
            <Typography
              variant="h6"
              fontWeight={700}
              color="var(--c-primary-1)"
            >
              ₦{getAmount(totalAmount)}
            </Typography>
          </Box>
        </Box>

        <DialogContentText fontSize="14px" textAlign="center" mb={2}>
          {isBulk
            ? `You are about to pay for ${
                paymentData?.plans?.length || 0
              } plan(s). Click Proceed to continue with payment.`
            : "Click Proceed to continue with payment via Paystack."}
        </DialogContentText>

        <Stack spacing={2} direction="row">
          <LoadingButton
            fullWidth
            sx={{
              borderRadius: "10px",
              bgcolor: "bg-[var(--text-bg)] !important",
            }}
            size="large"
            variant="outlined"
            onClick={handleClose}
          >
            <span>Cancel</span>
          </LoadingButton>

          <PaystackPayment
            loading={loading}
            config={paystackConfig}
            onSuccess={handleSuccess}
            onClose={console.log /*handleClose*/}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
